import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UuidGeneratorService {
  /**
   * Generates a UUID v4 string
   * @returns A UUID v4 string
   */
  generate(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
